import styled from 'styled-components';

export const HeaderContainer = styled.div`
  align-items: flex-start;
  background: white;
  border-bottom: 1px solid rgb(205, 199, 209);
  display: flex;
  justify-content: space-between;
  padding: 10px 32px 10px 15px;
`;

export const TabsContainer = styled.div`
  background: white;
  padding: 0 32px;
`;

export const HeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const BackButtonRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: center;
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  margin: -4px;
  color: rgb(26, 23, 28);
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.7;
  }

  &:active {
    opacity: 0.5;
  }
`;

export const SegmentName = styled.h1`
  font-size: 24px;
  font-family: Calibre-Semibold, sans-serif;
  color: rgb(26, 23, 28);
  margin: 0;
`;

export const SegmentNamePlaceholder = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`;

export const Description = styled.div`
  font-size: 16px;
  font-family: Calibre-Regular, sans-serif;
  color: rgb(26, 23, 28);
  padding-left: 34px;
  line-height: 1.5;
`;

export const DescriptionPlaceholder = styled.div`
  margin-top: 4px;
`;

export const EditButton = styled.button`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 10px 20px;
  background: rgb(80, 50, 140);
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-family: Calibre-Semibold, sans-serif;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover:not(:disabled) {
    background: rgb(60, 40, 110);
  }

  &:active:not(:disabled) {
    background: rgb(50, 30, 100);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ContentContainer = styled.div`
  padding: 24px 32px;
  background: rgb(240, 239, 241);
  min-height: calc(100vh - 200px);
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  box-sizing: border-box;
`;

export const ErrorMessage = styled.div`
  font-size: 16px;
  font-family: Calibre-Regular, sans-serif;
  color: rgb(200, 0, 0);
  margin-top: 8px;
`;

export const NoRecordContainer = styled.div`
  min-height: calc(100vh - 200px);
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  height: 80vh;
  background: rgb(240, 239, 241);
`;

export const NoRecordText = styled.div`
  font-size: 20px;
  font-family: Calibre-Regular, sans-serif;
  margin-top: 16px;
  margin-bottom: 8px;
`;

export const NoRecordSubText = styled.div`
  font-size: 16px;
  font-family: Calibre-Regular, sans-serif;
  color: rgb(128, 128, 128);
`;
